export default "__VITE_ASSET__CZzw4976__"